import { LoadingOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type IMeetStatus = 'FINISH' | 'INIT' | 'WAIT_DO' | 'UNKNOWN' | 'ERROR' | 'FAILED' | 'MERGING' | 'NO_ACCESS';

interface MeetStatusProps {
  meetStatus: IMeetStatus;
  handleEndMeeting?: () => void;
  contentType?: 'summary' | 'transcription';
}

const MeetStatus: React.FC<MeetStatusProps> = ({ meetStatus, handleEndMeeting, contentType }) => {
  const { t } = useTranslation();
  const [, setCountdown] = useState(30);

  useEffect(() => {
    if (meetStatus === 'WAIT_DO' || meetStatus === 'MERGING') {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            window.location.reload();
            return 30;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [meetStatus]);

  const handleEndMeetingClick = () => {
    Modal.confirm({
      title: t('meeting.confirmEndMeeting'),
      icon: null,
      content: t('meeting.endMeetingWarning'),
      okText: t('meeting.summary'),
      cancelText: t('meeting.cancel'),
      onOk() {
        handleEndMeeting?.();
      },
    });
  };

  const renderContent = () => {
    switch (meetStatus) {
      case 'ERROR':
      case 'FAILED':
        return (
          <div>
            <div className="warning-title">{t('meeting.getMeetingInfoFailed')}</div>
            <div className="warning-text">{t('meeting.getSummaryFailedReason')}</div>
            <ul className="warning-list">
              <li>{t('meeting.getSummaryFailedReason1')}</li>
              <li>{t('meeting.getSummaryFailedReason2')}</li>
              <li>{t('meeting.getSummaryFailedReason3')}</li>
            </ul>
            <span className="warning-text" style={{ marginTop: '0px' }}>{t('meeting.getSummaryFailedReason4')}</span>
          </div>
        );
      case 'UNKNOWN':
        return (
          <div className="loading-text">
            <LoadingOutlined />
            {t('meeting.gettingMeetingInfo')}
          </div>
        );
      case 'NO_ACCESS':
        return (
          <div className="loading-text">
            {contentType === 'transcription'
              ? t('meeting.transcriptionNotAvailable')
              : t('meeting.summaryNotAvailable')}
          </div>
        );
      case 'INIT':
        return (
          <>
            <div className="loading-text" style={{ textAlign: 'left' }}>
              {t('meeting.meetingInProgress')}
              <br />
              <br />
              {t('meeting.meetingEnded')}
              <Button onClick={handleEndMeetingClick} style={{ marginLeft: '10px' }}>{t('meeting.endMeetingAndSummary')}</Button>
            </div>
          </>
        );
      case 'WAIT_DO':
      case 'MERGING':
        return (
          <div className="loading-text">
            <LoadingOutlined />
            {t('meeting.processingMeeting')}
          </div>
        );
      case 'FINISH':
        return <div className="loading-text">{t('meeting.meetingInfoCompleted')}</div>;
      default:
        return <div className="loading-text">{t('meeting.meetingWaiting')}</div>;
    }
  };

  return (
    <div className="gemini-content">
      <div className="loading-container">
        {renderContent()}
      </div>
    </div>
  );
};

export default MeetStatus;
